// extracted by mini-css-extract-plugin
export default {"tableSortingHeaderContainer":"TheTableSortingHeader_tableSortingHeaderContainer__wbsPO"};